import { Box, Typography, useTheme } from "@mui/material"

import { Carousel, CarouselItem } from "components/Carousel"
import { useState } from "react"
import { useTranslation } from "providers/i18n"
import { LeftToRightWrapper } from "components/LeftToRightWrapper"
import { SeeAndDoModal } from "./SeeAndDoModal"
import { useSeeAndDo } from "extensions/one-siam/hooks"

export const SeeAndDoButton = () => {
  const { t } = useTranslation()
  const { hasData, sortedPostByDefaultVenue } = useSeeAndDo()
  const theme = useTheme()
  const { root, carousel, carouselItem, image, labelText } =
    theme.components?.[`SeeAndDoButton`].styleOverrides || {}
  const { carouselOptions = {} } =
    theme.components?.[`SeeAndDoButton`].defaultProps || {}

  const [open, setOpen] = useState(false)

  const handleClick = () => {
    setOpen(true)
  }

  const handleCloseModal = () => {
    setOpen(false)
  }

  return (
    <>
      {hasData && (
        <LeftToRightWrapper>
          <Box sx={root} onClick={handleClick}>
            <Carousel
              options={{
                type: "fade",
                rewind: true,
                autoplay: true,
                pagination: false,
                interval: 3000,
                arrows: false,
                speed: 1500,
                padding: 10,
                ...carouselOptions,
              }}
              sx={carousel}
            >
              {sortedPostByDefaultVenue.map((post) => {
                return (
                  <CarouselItem key={post.id} sx={carouselItem}>
                    <Box
                      sx={image}
                      component="img"
                      src={post?.properties?.feature_image}
                    />
                  </CarouselItem>
                )
              })}
            </Carousel>
            <Typography sx={labelText}>{t("See & Do")}</Typography>
          </Box>
        </LeftToRightWrapper>
      )}
      <SeeAndDoModal
        data={sortedPostByDefaultVenue}
        open={open}
        onClose={handleCloseModal}
      />
    </>
  )
}
